// =========================================================
// SECTION UNIVERS — recul des cartes empilées (maquette Figma 287:1390).
// L'épinglage de la pile est en CSS pur (sticky, top incrémenté — cf. SCSS) :
// ici on n'anime QUE le « recul » de la carte recouverte (scale + voile beige
// --km-veil), chaque niveau de profondeur un peu plus étroit/fondu.
//
// Recul = tween DÉCLENCHÉ (durée + easing fixes), PAS un scrub : scrubbé, le
// rétrécissement est proportionnel à la distance de scroll → un coup de
// molette rapide l'exécute d'un bloc, rendu « brusque » (retour Olivier,
// 3ᵉ itération — scrub true puis scrub amorti, toujours jugés secs).
// onEnter/onLeaveBack par paire (carte i recouverte par la carte j), avec
// overwrite:'auto' pour les passages rapides sur plusieurs seuils.
//
// ⚠️ Le scale s'applique au wrapper interne __card-inner, JAMAIS au sticky
// lui-même (compositeur vs GSAP → tremblement au scroll, vécu en preprod).
// JAMAIS gsap.from().
// =========================================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SCALE_STEP = 0.035; // rétrécissement par niveau de profondeur
const VEIL_STEP = 0.14; // fondu vers le beige par niveau (--km-veil, cf. SCSS ::after)
const EASE = 'power2.out';
const DURATION = 1.2;

document.addEventListener('DOMContentLoaded', () => {

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.km-univers').forEach((section) => {

        const cards = Array.from(section.querySelectorAll('.km-univers__card'));
        if (cards.length < 2) return;

        const recede = (inner, depth) => gsap.to(inner, {
            scale: 1 - depth * SCALE_STEP,
            '--km-veil': depth * VEIL_STEP,
            duration: DURATION,
            ease: EASE,
            overwrite: 'auto',
        });

        cards.forEach((card, i) => {
            const inner = card.querySelector('.km-univers__card-inner');
            if (!inner) return;
            for (let j = i + 1; j < cards.length; j++) {
                const depth = j - i; // niveaux de recouvrement de la carte i
                ScrollTrigger.create({
                    trigger: cards[j],
                    // la carte j entre dans le bas de l'écran → la carte i
                    // anime son recul pendant que j glisse par-dessus
                    start: 'top 80%',
                    onEnter: () => recede(inner, depth),
                    onLeaveBack: () => recede(inner, depth - 1),
                });
            }
        });
    });

});
